import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="px-8 pb-20 w-1/4">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
